/**
 * Empty state rendered by every per-site surface (Workforce, Cohort
 * Builder, Review Queue, Live Sessions) when the org subscription is
 * applied and returns zero rows the caller can see.
 *
 * Internal naming note: TurboTwin stores Sites in a `project` table — the
 * data layer says "project", the UI says "Site". This component name
 * (`NoProjects`) is internal-only; the visible copy is consistently "Site".
 */

import { useProjects } from '@/hooks/useProjects';

export function NoProjects({ pageName }: { pageName: string }) {
  const { isReady } = useProjects();
  return (
    <>
      <div className="page-head">
        <div>
          <h1 style={{ margin: 0, fontSize: 18 }}>{pageName}</h1>
          <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 2 }}>
            Per-site surface · waiting on a site
          </div>
        </div>
      </div>
      <div className="page-body">
        <div
          className="card"
          style={{
            padding: 24,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            alignItems: 'flex-start',
            maxWidth: 560,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 600 }}>
            {isReady ? 'No sites available' : 'Loading sites…'}
          </div>
          {isReady ? (
            <>
              <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>
                {pageName} is scoped per site. Your account doesn&apos;t
                have access to any sites yet, so there&apos;s nothing to show.
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>
                Ask an org admin to grant access in TurboTwin. Once you have
                at least one site, it appears in the topbar picker.
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}
